export function contactFunc() {
    // 入力内容を格納するための変数
    let val;
    // 入力フィールドのタイプを格納するための変数
    let type;
    // ラジオボタンの選択値を格納するための変数
    let radio;
    // チェックボックスの選択値を格納するための変数
    let check;

    // 郵便番号検索機能
    function initPostalCodeSearch() {
        const zipSearchBtn = document.getElementById('zip-search');
        const cityInput = document.getElementById('your-city');
        const zipInput = document.getElementById('postal-code');
        const prefectureSelect = document.getElementById('your-prefectures');

        if (!zipSearchBtn || !cityInput || !zipInput) {
            return;
        }

        // 郵便番号検索ボタンのクリックイベント
        zipSearchBtn.addEventListener('click', function() {
            const zipCode = zipInput.value.trim();
            
            if (!zipCode) {
                alert('郵便番号を入力してください');
                return;
            }

            // 郵便番号の形式チェック（7桁の数字）
            const zipPattern = /^\d{7}$/;
            if (!zipPattern.test(zipCode)) {
                alert('郵便番号は7桁の数字で入力してください（例：1234567）');
                return;
            }

            // ローディング表示
            zipSearchBtn.disabled = true;
            zipSearchBtn.textContent = '検索中...';

            // 郵便番号検索API（zipcloud）
            fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipCode}`)
                .then(response => response.json())
                .then(data => {
                    if (data.status === 200 && data.results && data.results.length > 0) {
                        const result = data.results[0];
                        const city = result.address2 + result.address3; // 市区町村
                        const prefecture = result.address1; // 都道府県
                        
                        // 市町村フィールドに自動入力
                        cityInput.value = city;
                        
                        // 都道府県セレクトボックスに自動選択
                        if (prefectureSelect) {
                            // 都道府県のオプションを検索して選択
                            const options = prefectureSelect.querySelectorAll('option');
                            for (let option of options) {
                                if (option.value === prefecture) {
                                    option.selected = true;
                                    break;
                                }
                            }
                        }

                        // 確認画面にも反映
                        const confirmCityElement = document.querySelector('.confirm_your-city');
                        if (confirmCityElement) {
                            confirmCityElement.textContent = city;
                        }
                        const confirmPrefectureElement = document.querySelector('.confirm_your-prefectures');
                        if (confirmPrefectureElement) {
                            confirmPrefectureElement.textContent = prefecture;
                        }

                        // バリデーションエラーをクリア
                        cityInput.classList.remove('wpcf7-not-valid');
                        cityInput.setAttribute('aria-invalid', 'false');
                        const errorTip = cityInput.parentNode.querySelector('.wpcf7-not-valid-tip');
                        if (errorTip) {
                            errorTip.style.display = 'none';
                        }

                    } else {
                        alert('郵便番号が見つかりませんでした。正しい郵便番号を入力してください。');
                    }
                })
                .catch(error => {
                    console.error('郵便番号検索エラー:', error);
                    alert('住所の検索中にエラーが発生しました。しばらく時間をおいてから再度お試しください。');
                })
                .finally(() => {
                    // ボタンの状態を元に戻す
                    zipSearchBtn.disabled = false;
                    zipSearchBtn.textContent = '郵便番号から検索';
                });
        });

        // 郵便番号入力時の自動検索（オプション）
        zipInput.addEventListener('blur', function() {
            const zipCode = this.value.trim();
            if (zipCode.length === 7 && /^\d{7}$/.test(zipCode)) {
                // 自動検索を実行
                zipSearchBtn.click();
            }
        });
    }
    
    // Contact Form 7のフォームが読み込まれた後に実行
    function initFormHandlers() {
        // 郵便番号検索機能を初期化
        initPostalCodeSearch();
        // ラジオボタンの初期値を取得し、確認画面に反映させる
        const radioButtons = document.querySelectorAll('.form__data-radio [type="radio"]:checked');
        radioButtons.forEach(button => {
            // ラジオボタンの選択値を取得
            radio = button.value;
            // ラジオボタンのname属性を取得（IDの代わりにnameを使用）
            const name = button.name;
            // 取得したnameをクラス名に追加し、確認画面の値を設定
            const confirmElement = document.querySelector(`.confirm_${name}`);
            if (confirmElement) {
                confirmElement.textContent = radio;
            }
        });

        // 入力フィールドの内容が変更された場合の処理
        const formInputs = document.querySelectorAll('.form__data input, .form__data select, .form__data textarea, .form__data-radio input');
        
        formInputs.forEach(input => {
            input.addEventListener('change', function () {
                // 入力内容を取得
                val = this.value;
                // 入力フィールドのタイプを取得
                type = this.getAttribute("type");
                
                // ラジオボタンの場合の処理
                if (type === "radio") {
                    // ラジオボタンの選択値を取得
                    radio = this.value;
                    // ラジオボタンのname属性を取得
                    const name = this.name;
                    // 取得したnameをクラス名に追加し、確認画面の値を設定
                    const confirmElement = document.querySelector(`.confirm_${name}`);
                    if (confirmElement) {
                        confirmElement.textContent = radio;
                    }
                }// チェックボックスの場合の処理
                else if (type === "checkbox") {
                    // チェックボックスの選択値を取得
                    check = this.value;
                    // チェックボックスの親要素からidを取得
                    const id = this.closest("[id]").id;
                    // 取得したidをクラス名に追加し、確認画面の値を設定
                    const confirmElement = document.querySelector(`.confirm_${id}`);
                    if (confirmElement) {
                        confirmElement.textContent += check + " / ";
                    }
                }// その他の場合の処理
                else {
                    // 入力フィールドのidを取得
                    const id = this.id;
                    // 取得したidをクラス名に追加し、確認画面の値を設定
                    const confirmElement = document.querySelector(`.confirm_${id}`);
                    if (confirmElement) {
                        confirmElement.textContent = val;
                    }
                }
            });
        });
    }

    // DOMが読み込まれた後に実行
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFormHandlers);
    } else {
        initFormHandlers();
    }

    // Contact Form 7のフォームが更新された後に実行
    document.addEventListener('wpcf7mailsent', initFormHandlers);
    document.addEventListener('wpcf7invalid', initFormHandlers);
    document.addEventListener('wpcf7spam', initFormHandlers);
    document.addEventListener('wpcf7mailfailed', initFormHandlers);
    
    // Contact Form 7のフォームが読み込まれた後に実行
    document.addEventListener('wpcf7formready', initFormHandlers);

    // 確認ボタンをクリックした場合の処理
    const confirmButton = document.querySelector(".confirm_button");
    if (confirmButton) {
        confirmButton.addEventListener('click', () => {
            // 現在のフォームの値を確認画面に反映
            const formInputs = document.querySelectorAll('.form__data input, .form__data select, .form__data textarea, .form__data-radio input');
            formInputs.forEach(input => {
                const val = input.value;
                const type = input.getAttribute("type");
                const id = input.id;

                if (type === "radio" && input.checked) {
                    const radioName = input.name;
                    const confirmElement = document.querySelector(`.confirm_${radioName}`);
                    if (confirmElement) {
                        confirmElement.textContent = val;
                    }
                } else if (type === "checkbox" && input.checked) {
                    const checkboxId = input.closest("[id]").id;
                    const confirmElement = document.querySelector(`.confirm_${checkboxId}`);
                    if (confirmElement) {
                        confirmElement.textContent += val + " / ";
                    }
                } else if (id) {
                    const confirmElement = document.querySelector(`.confirm_${id}`);
                    if (confirmElement) {
                        confirmElement.textContent = val;
                    }
                }
            });

            const formOtherArea = document.querySelector(".form_other_area");
            if (formOtherArea) {
                formOtherArea.style.display = 'none';
            }
            document.querySelector(".form_area").style.display = 'none';
            document.querySelector(".confirm_area").style.display = 'block';
            window.scrollTo(0, document.querySelector('.top-contact').getBoundingClientRect().top);
        });
    }

    // 戻るボタンをクリックした場合の処理
    const backButton = document.querySelector(".back_button");
    backButton.addEventListener('click', () => {
        const formOtherArea = document.querySelector(".form_other_area");
        if (formOtherArea) {
            formOtherArea.style.display = 'none';
        }
        document.querySelector(".form_area").style.display = 'block';
        document.querySelector(".confirm_area").style.display = 'none';
        window.scrollTo(0, document.querySelector('.top-contact').getBoundingClientRect().top);
    });

    // 必須項目が変更された場合の処理
    const requiredInputs = document.querySelectorAll('[aria-required="true"]');
    requiredInputs.forEach(input => {
        input.addEventListener('input', () => {
            // フラグ
            let flag = true;
            // 必須項目をループで確認
            requiredInputs.forEach(requiredInput => {
                if (requiredInput.value === "") {
                    flag = false;
                }
            });
            // フラグに基づいて確認ボタンを有効化/無効化
            confirmButton.disabled = !flag;
        });
    });

    // 送信ボタンをクリックした場合の処理
    document.addEventListener('wpcf7mailsent', (event) => {
        // 完了画面を表示
        document.querySelector(".form_area").style.display = 'none';
        document.querySelector(".confirm_area").style.display = 'none';
        document.querySelector(".thanks_area").style.display = 'block';
        window.scrollTo(0, document.querySelector('.top-contact').getBoundingClientRect().top);
    }, false);

}